(function () {
  'use strict';

  if (window.SPTracking) return;

  var configNode = document.querySelector('[data-sp-tracking-config]');
  var config = {};
  try {
    config = JSON.parse(configNode ? configNode.textContent : '{}');
  } catch (error) {
    config = {};
  }

  var prefix = 'seniorenportal:';
  var googleAdsStorageKey = 'sp_google_ads_attribution_v1';
  var queued = [];
  var initialized = false;
  var privacyApiLoadStarted = false;
  var privacyApiLoadAttempts = 0;
  var privacyApiReadyResolve;
  var privacyApiReady = new Promise(function (resolve) {
    privacyApiReadyResolve = resolve;
  });

  function clean(value) {
    return value == null ? '' : String(value).trim();
  }

  function numberOrNull(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function safeUrl(value) {
    try {
      return new URL(value, window.location.href);
    } catch (error) {
      return null;
    }
  }

  function privacyContext() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy
      || typeof privacy.marketingAllowed !== 'function'
      || typeof privacy.analyticsProcessingAllowed !== 'function') {
      return {
        ready: false,
        marketing: false,
        analytics: false,
        sale_of_data: false
      };
    }

    return {
      ready: true,
      marketing: privacy.marketingAllowed() === true,
      analytics: privacy.analyticsProcessingAllowed() === true,
      sale_of_data: typeof privacy.saleOfDataAllowed === 'function' && privacy.saleOfDataAllowed() === true
    };
  }

  function finishPrivacyApiLoad() {
    refreshGoogleAdsAttribution();
    privacyApiReadyResolve(privacyContext().ready);
  }

  function loadCustomerPrivacyApi() {
    if (privacyContext().ready) {
      finishPrivacyApiLoad();
      return;
    }
    if (privacyApiLoadStarted) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      privacyApiLoadAttempts += 1;
      if (privacyApiLoadAttempts >= 40) {
        privacyApiReadyResolve(false);
        return;
      }
      window.setTimeout(loadCustomerPrivacyApi, 50);
      return;
    }

    privacyApiLoadStarted = true;
    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' }
    ], function () {
      finishPrivacyApiLoad();
    });
  }

  function validClickId(value) {
    var text = clean(value);
    return /^[A-Za-z0-9._~-]{1,256}$/.test(text) ? text : null;
  }

  function googleAdsFromLocation() {
    var result = {};
    try {
      var params = new URLSearchParams(window.location.search);
      ['gclid', 'gbraid', 'wbraid'].forEach(function (key) {
        var value = validClickId(params.get(key));
        if (value) result[key] = value;
      });
    } catch (error) {}
    return result;
  }

  function refreshGoogleAdsAttribution() {
    var consent = privacyContext();
    if (!consent.ready) return consent;

    try {
      if (!consent.marketing) {
        window.sessionStorage.removeItem(googleAdsStorageKey);
        return consent;
      }

      var fromLocation = googleAdsFromLocation();
      if (Object.keys(fromLocation).length) {
        window.sessionStorage.setItem(googleAdsStorageKey, JSON.stringify(fromLocation));
      }
    } catch (error) {}

    return consent;
  }

  function checkoutContext() {
    var consent = refreshGoogleAdsAttribution();
    var googleAds = {};

    if (consent.marketing) {
      try {
        var stored = JSON.parse(window.sessionStorage.getItem(googleAdsStorageKey) || '{}');
        ['gclid', 'gbraid', 'wbraid'].forEach(function (key) {
          var value = validClickId(stored[key]);
          if (value) googleAds[key] = value;
        });
      } catch (error) {}
    }

    return {
      consent: {
        marketing: consent.marketing ? 'granted' : 'denied',
        analytics: consent.analytics ? 'granted' : 'denied',
        sale_of_data: consent.sale_of_data ? 'granted' : 'denied'
      },
      google_ads: googleAds
    };
  }

  function whenPrivacyReady() {
    loadCustomerPrivacyApi();
    return Promise.race([
      privacyApiReady,
      new Promise(function (resolve) {
        window.setTimeout(function () { resolve(false); }, 2000);
      })
    ]);
  }

  function publishNow(eventName, eventData) {
    var payload = Object.assign({
      shop_domain: config.shop_domain || '',
      page_type: config.page_type || '',
      page_path: config.page_path || window.location.pathname,
      collection_id: config.collection_id || null
    }, eventData || {});

    document.dispatchEvent(new CustomEvent('sp:tracking:published', {
      detail: { name: eventName, data: payload }
    }));

    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') {
      queued.push([eventName, payload]);
      return false;
    }

    try {
      window.Shopify.analytics.publish(prefix + eventName, payload);
      return true;
    } catch (error) {
      queued.push([eventName, payload]);
      return false;
    }
  }

  function flushQueue() {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    var pending = queued.splice(0, queued.length);
    pending.forEach(function (entry) {
      publishNow(entry[0], entry[1]);
    });
  }

  function cardData(card) {
    return {
      product_id: clean(card.dataset.spProductId),
      variant_id: clean(card.dataset.spVariantId) || null,
      context: clean(card.dataset.spContext) || config.page_type || 'unknown',
      position: numberOrNull(card.dataset.spPosition)
    };
  }

  function observeProductCards(root) {
    var cards = (root || document).querySelectorAll('[data-sp-product-card]:not([data-sp-impression-bound])');
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.dataset.spImpressionBound = 'true';
        publishNow('product_impression', cardData(card));
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          if (card.__spImpressionTimer) return;
          card.__spImpressionTimer = window.setTimeout(function () {
            card.__spImpressionTimer = null;
            if (card.dataset.spImpressionSent === 'true') return;
            card.dataset.spImpressionSent = 'true';
            observer.unobserve(card);
            publishNow('product_impression', cardData(card));
          }, 1000);
        } else if (card.__spImpressionTimer) {
          window.clearTimeout(card.__spImpressionTimer);
          card.__spImpressionTimer = null;
        }
      });
    }, { threshold: [0.5] });

    cards.forEach(function (card) {
      card.dataset.spImpressionBound = 'true';
      observer.observe(card);
    });
  }

  function trackClicks() {
    document.addEventListener('click', function (event) {
      var anchor = event.target.closest && event.target.closest('a');
      if (!anchor) return;

      var card = anchor.closest('[data-sp-product-card]');
      if (card && anchor.matches('[data-product-page-link]')) {
        publishNow('product_click', cardData(card));
        return;
      }

      var target = safeUrl(anchor.href);
      if (!target || !/^https?:$/.test(target.protocol) || target.host === window.location.host) return;

      var ctaRoot = anchor.closest('[data-sp-external-cta]');
      var variantInput = ctaRoot && ctaRoot.querySelector('form [name="id"], [name="id"][data-variants]');
      publishNow('external_linkout', {
        product_id: ctaRoot ? clean(ctaRoot.dataset.productId) : null,
        variant_id: variantInput ? clean(variantInput.value) : null,
        context: ctaRoot ? 'product_cta' : 'external_link',
        target_host: target.hostname,
        target_path: target.pathname
      });
    }, true);
  }

  function init() {
    if (initialized) return;
    initialized = true;
    refreshGoogleAdsAttribution();
    observeProductCards(document);
    trackClicks();
    flushQueue();

    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) observeProductCards(node.matches('[data-sp-product-card]') ? node.parentNode : node);
        });
      });
    });
    mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setInterval(flushQueue, 1000);
  }

  window.SPTracking = {
    publish: publishNow,
    flush: flushQueue,
    checkoutContext: checkoutContext,
    whenPrivacyReady: whenPrivacyReady
  };

  document.addEventListener('shopifyCustomerPrivacyApiLoaded', finishPrivacyApiLoad);
  document.addEventListener('visitorConsentCollected', refreshGoogleAdsAttribution);

  loadCustomerPrivacyApi();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
